// 5 durumlu sistem - kanban sırası (soldan sağa güç sırası)
export const STATUSES = ["Yetki belgesi", "Onay", "Beyaz", "Askı", "Karşıda"];

export const STATUS_META = {
  "Yetki belgesi": {
    key: "yetki",
    label: "Yetki Belgesi Alınan Üyeler",
    short: "Yetki",
    option: "Yetki Belgesi Alındı",
    bg: "bg-emerald-50 dark:bg-emerald-950/40",
    border: "border-emerald-500",
    text: "text-emerald-800 dark:text-emerald-300",
    indicator: "bg-emerald-600",
    dot: "#10B981",
    ring: "ring-emerald-500",
    desc: "Yeşil",
  },
  Onay: {
    key: "onay",
    label: "Onay/Söz Alınan Üyeler",
    short: "Onay",
    option: "Onay/Söz Alındı",
    bg: "bg-amber-50 dark:bg-amber-950/40",
    border: "border-amber-500",
    text: "text-amber-900 dark:text-amber-300",
    indicator: "bg-amber-500",
    dot: "#F59E0B",
    ring: "ring-amber-500",
    desc: "Sarı",
  },
  Beyaz: {
    key: "beyaz",
    label: "Belirsiz Üyeler",
    short: "Belirsiz",
    option: "Belirsiz",
    bg: "bg-neutral-50 dark:bg-neutral-800/60",
    border: "border-neutral-300 dark:border-neutral-600",
    text: "text-neutral-700 dark:text-neutral-300",
    indicator: "bg-neutral-300 dark:bg-neutral-500",
    dot: "#E5E7EB",
    ring: "ring-neutral-400",
    desc: "Beyaz",
  },
  Askı: {
    key: "aski",
    label: "Askıdaki Üyeler",
    short: "Askıda",
    option: "Askıda",
    bg: "bg-blue-50 dark:bg-blue-950/40",
    border: "border-blue-500",
    text: "text-blue-800 dark:text-blue-300",
    indicator: "bg-blue-600",
    dot: "#3B82F6",
    ring: "ring-blue-500",
    desc: "Mavi",
  },
  Karşıda: {
    key: "karsi",
    label: "Rakip Aday Destekçileri",
    short: "Karşıda",
    option: "Karşı Tarafta",
    bg: "bg-red-50 dark:bg-red-950/40",
    border: "border-red-500",
    text: "text-red-800 dark:text-red-300",
    indicator: "bg-red-600",
    dot: "#EF4444",
    ring: "ring-red-500",
    desc: "Kırmızı",
  },
};

// Bizim taraf: kesin veya sözlü desteğimiz olanlar.
export const OUR_SIDE = ["Yetki belgesi", "Onay"];
// Henüz ikna edilmemiş olanlar.
export const OPEN_WORK = ["Beyaz", "Askı", "Karşıda"];

/* ————————————————————— Rota ekranı ————————————————————— */
/**
 * Rota ekranının tamamı tek bir kavramdan türer: **aktif hedef kümesi**.
 * Üstteki süzgeç düğmeleri bu kümeyi belirler; sayaçlar, hangi sokağın
 * görüneceği, kimin belirgin kimin soluk çizileceği ve rota bağlantısındaki
 * duraklar hep buradan okunur.
 *
 * Varsayılan hedef askıdakiler ve belirsizler. Karşı taraftakiler bilerek
 * dışarıda: oyları alınamayacağı için çaya gidilecekler arasında yer kaplayıp
 * rotayı şişiriyorlardı.
 */
export const VISIT_DEFAULT = ["Askı", "Beyaz"];

/**
 * Süzgeç düğmeleri — ekrandaki soldan sağa sıra.
 * Onay/söz alınanlar da açılabiliyor: yetki belgesi almak için o üyelere
 * tekrar gitmek gerekebiliyor.
 */
export const VISIT_FILTERS = ["Askı", "Beyaz", "Onay"];

/**
 * Rota listesinde kategori sırası. Liste bu sıraya göre bloklanır; iki onaylı
 * üyenin arasına başka kategoriden üye girmez.
 */
export const VISIT_ORDER = ["Askı", "Beyaz", "Onay", "Yetki belgesi", "Karşıda"];

/**
 * Bu sayıdan az üyesi olan sokak kendi satırını hak etmez; mahallenin
 * "Dağınık adresler" kutusuna girer, sokak adı üye satırında etiket olarak
 * kalır. Veride 167 sokağın 121'inde tek üye var — her biri ayrı açılır liste
 * olunca ekran okunmaz hâle geliyordu.
 *
 * "En yakın sokağa kat" yolu bilerek seçilmedi: elde sokak koordinatı yok,
 * komşuluk uydurmak olurdu. Aynı mahalle içinde toplamak hem doğru hem yeterli.
 */
export const SCATTER_MIN = 3;

// Rota ekranının dili: gidilip görüşülecek üyeler için kullanılan tabir.
export const VISIT_LABEL = "çaya gidilecek";
export const VISIT_LABEL_LONG = "Çaya gidilecek üyeler";

// Şirket türü oy kullanma şeklini belirler:
// tüzel kişi (firma) yetki belgesiyle, şahıs şirketi kimliğiyle oy kullanır.
export const ENTITY_TYPES = ["Firma", "Şahıs"];

/**
 * Unvandan şahıs/firma tahmini — arka uçtaki derive_entity_type ile aynı kural.
 * A.Ş. kalıbının iki yanındaki kelime sınırları şart: sınırsız hâli YURTTAŞ /
 * DEMİRTAŞ / ULAŞ gibi soyadlarının sonundaki AŞ ekini A.Ş. sanıyor.
 */
const TUZEL_RE =
  /(\bLTD\b|LİMİTED|ŞİRKET|SIRKET|\bŞTİ\b|\bA\.?\s?Ş\.?(?=\s|$)|ANONİM|KOLLEKTİF|KOMANDİT|KOOPERATİF|HOLDİNG)/i;

export const deriveEntityType = (company) =>
  TUZEL_RE.test(company || "") ? "Firma" : "Şahıs";

export const ENTITY_META = {
  Firma: {
    key: "firma",
    label: "Şirket",
    long: "Tüzel kişi",
    vote: "Yetki belgesi ile oy kullanır",
    short: "Şirket",
    dot: "#6366F1",
    bg: "bg-indigo-50 dark:bg-indigo-950/40",
    text: "text-indigo-700 dark:text-indigo-300",
    border: "border-indigo-200 dark:border-indigo-900",
  },
  Şahıs: {
    key: "sahis",
    label: "Şahıs",
    long: "Şahıs şirketi",
    vote: "Kimliği ile oy kullanır",
    short: "Şahıs",
    dot: "#14B8A6",
    bg: "bg-teal-50 dark:bg-teal-950/40",
    text: "text-teal-700 dark:text-teal-300",
    border: "border-teal-200 dark:border-teal-900",
  },
};

// Seçim tarihi arka uçtan gelir; bu yalnızca ilk çizimdeki yedek değer.
export const DEFAULT_ELECTION_AT = "2026-10-03T09:00:00+03:00";

// Bu sistem yalnızca tek komiteye özeldir.
export const DEFAULT_COMMITTEE = "MOBİLYA TOP. VE PERAKENDE";
export const COMMITTEES = [DEFAULT_COMMITTEE];
